import React from 'react';
import {useMemo, useState} from 'react';

export default ({onChange, value}) => {
    const [ loading, setLoading ] = useState(true);
    const [ labs, setLabs ] = useState(false);

    const labReq = useMemo(async () => {
        const resp = await fetch(`/webservice2/lab?token=${window.admin}`);
        const json = await resp.json();
        return json.foundrecord.foundrecord_items
    }, []);
    labReq.then(json => {
        setLabs(json);
        setLoading(false);
    });
    return (
        <select id="userlab"
                className="form-control"
                onChange={onChange}
                value={value}
                name="lab"
                disabled={loading}
        >
            {
                loading ? <option value="">Loading...</option>
                    : <React.Fragment>
                        <option value="">All</option>
                        {
                            labs.map(l => {
                                return (
                                    <option key={l.browselabrecord.labid}
                                            value={l.browselabrecord.labid}>{l.browselabrecord.labname}</option>
                                )
                            })
                        }
                    </React.Fragment>

            }

        </select>
    )
}
